export const BuildUtil = {
    VERSION : "202411201631:PRERELEASE"
}